import { MOCK_CAMPAIGN_SEND_STATS } from './mock-campaign-send-stats';
import { toReportCampaignRow } from '../mappers/campaign-send-stats.mapper';
import type { CampaignStats, ReportCampaignRow } from '../types/reports.types';

/** UI-shaped rows derived from Blocks CampaignSendStats mocks. */
export const MOCK_REPORT_CAMPAIGNS: ReportCampaignRow[] = MOCK_CAMPAIGN_SEND_STATS.map(
  toReportCampaignRow
);

/** Prior-period totals used when the prior window has no mock docs. */
export const MOCK_PRIOR_TOTALS: CampaignStats = {
  audience: 2100,
  sent: 1380,
  delivered: 1360,
  bounced: 20,
  bouncedHard: 12,
  bouncedSoft: 8,
  uniqueOpens: 333,
  uniqueClicks: 84,
  complaints: 0,
  unsubscribes: 6,
  skipTotal: 80,
  sendableCount: 2020,
  balances: true,
  computedAt: new Date().toISOString(),
};

export const MOCK_LINK_ROWS: Record<
  string,
  Array<{ linkId: string; url: string; label: string; clicks: number; uniqueClicks: number }>
> = {
  'cmp-digest': [
    {
      linkId: 'lnk-1',
      url: 'https://example.com/pricing',
      label: 'See pricing',
      clicks: 28,
      uniqueClicks: 22,
    },
    {
      linkId: 'lnk-2',
      url: 'https://example.com/blog/weekly',
      label: 'Read the digest',
      clicks: 18,
      uniqueClicks: 15,
    },
    {
      linkId: 'lnk-3',
      url: 'https://example.com/unsubscribe',
      label: 'Unsubscribe',
      clicks: 4,
      uniqueClicks: 4,
    },
  ],
  'cmp-reeng': [
    {
      linkId: 'lnk-r1',
      url: 'https://example.com/welcome-back',
      label: 'Come back',
      clicks: 22,
      uniqueClicks: 19,
    },
    {
      linkId: 'lnk-r2',
      url: 'https://example.com/preferences',
      label: 'Update preferences',
      clicks: 9,
      uniqueClicks: 8,
    },
  ],
  'cmp-autumn': [
    {
      linkId: 'lnk-a1',
      url: 'https://example.com/launch',
      label: 'Explore the launch',
      clicks: 40,
      uniqueClicks: 31,
    },
    {
      linkId: 'lnk-a2',
      url: 'https://example.com/pricing',
      label: 'See pricing',
      clicks: 16,
      uniqueClicks: 14,
    },
    {
      linkId: 'lnk-a3',
      url: 'https://example.com/unsubscribe',
      label: 'Unsubscribe',
      clicks: 6,
      uniqueClicks: 6,
    },
  ],
};

export const SKIP_LABEL: Record<string, string> = {
  suppressed: 'Suppressed',
  unsubscribed: 'Unsubscribed',
  invalid: 'Invalid address',
  missing: 'Missing contact',
};

export { MOCK_CAMPAIGN_SEND_STATS, mockCampaignSendStatsListResponse } from './mock-campaign-send-stats';
